import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, BookOpenIcon, MessageSquareIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
export function ContactSection() {
  return <section id="contact" data-component="COMP-09-ContactSection" className="py-24 bg-white" data-id="element-110">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-112">
          {/* Left Side: Copy & Info */}
          <div data-id="element-113">
            <motion.span initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="block text-sm font-bold tracking-widest uppercase mb-3 text-gold-600" data-id="element-114">
              Get In Touch
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-bold text-navy-900 mb-6" data-id="element-115">
              Ready to join the team?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-navy-600 mb-10" data-id="element-116">
              Whether you're a parent looking to book a session, a school
              interested in our programmes, or a coach wanting to join our
              ranks, we'd love to hear from you.
            </motion.p>

            <div className="space-y-6" data-id="element-117">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="flex items-start" data-id="element-118">
                <div className="w-12 h-12 rounded-full bg-navy-50 flex items-center justify-center text-brand-blue mr-4 flex-shrink-0" data-id="element-119">
                  <MailIcon className="w-6 h-6" data-id="element-120" />
                </div>
                <div data-id="element-121">
                  <h4 className="font-bold text-navy-900 text-lg" data-id="element-122">
                    General Enquiries
                  </h4>
                  <p className="text-navy-600" data-id="element-123">
                    Questions about bookings or sessions.
                  </p>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="flex items-start" data-id="element-124">
                <div className="w-12 h-12 rounded-full bg-navy-50 flex items-center justify-center text-brand-coral mr-4 flex-shrink-0" data-id="element-125">
                  <BookOpenIcon className="w-6 h-6" data-id="element-126" />
                </div>
                <div data-id="element-127">
                  <h4 className="font-bold text-navy-900 text-lg" data-id="element-128">
                    Schools & Workshops
                  </h4>
                  <p className="text-navy-600" data-id="element-129">
                    Bring Bright Star to your school.
                  </p>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5
            }} className="flex items-start" data-id="element-130">
                <div className="w-12 h-12 rounded-full bg-navy-50 flex items-center justify-center text-brand-green mr-4 flex-shrink-0" data-id="element-131">
                  <MessageSquareIcon className="w-6 h-6" data-id="element-132" />
                </div>
                <div data-id="element-133">
                  <h4 className="font-bold text-navy-900 text-lg" data-id="element-134">
                    Partnerships
                  </h4>
                  <p className="text-navy-600" data-id="element-135">
                    Sponsorship and collaboration opportunities.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>

          {/* Right Side: Form */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} data-id="element-136">
            <ContactForm data-id="element-137" />
          </motion.div>
        </div>
      </div>
    </section>;
}